var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOffDutySpots = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 198,
  height: 43,
  fill: "none"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.515,
  cy: 12.5,
  fill: "#262B2F",
  rx: 2.515,
  ry: 2.5
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 194.629,
  cy: 31.5,
  fill: "#262B2F",
  rx: 2.515,
  ry: 2.5
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 127.741,
  cy: 26,
  fill: "#262B2F",
  rx: 4.023,
  ry: 4
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 22.631,
  cy: 1.5,
  fill: "#262B2F",
  rx: 1.509,
  ry: 1.5
})), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 161.939,
  cy: 11,
  fill: "#262B2F",
  rx: 2.012,
  ry: 2
})), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 160.933,
  cy: 42,
  fill: "#262B2F",
  rx: 1.006,
  ry: 1
})));
export default SvgOffDutySpots;